import get from 'lodash/get';
import defaultState from '../../state';
import {
  SHOW_REDIRECTING_TO,
  HIDE_REDIRECTING_TO,
  SET_REDIRECTING_TO_COUNT,
  SET_REDIRECTING_TO_PUBLISH_YOUR_CV,
  INCREMENT_REDIRECTING_TO_COUNT,
} from './actionTypes';
import { SOURCES_MODULE_NAME, REDIRECTING_TO_STATE_NAME } from '../constants';

export const initialState = get(defaultState, [SOURCES_MODULE_NAME, REDIRECTING_TO_STATE_NAME]);

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_REDIRECTING_TO:
      return {
        ...state,
        isShow: true,
        redirectUrl: action.payload,
      };

    case HIDE_REDIRECTING_TO:
      return {
        ...state,
        isShow: false,
        redirectUrl: '',
        publishYourCv: null,
      };

    case SET_REDIRECTING_TO_COUNT:
      return {
        ...state,
        count: action.payload,
      };

    case SET_REDIRECTING_TO_PUBLISH_YOUR_CV:
      return {
        ...state,
        publishYourCv: action.payload,
      };

    case INCREMENT_REDIRECTING_TO_COUNT:
      return {
        ...state,
        count: state.count + 1,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/Sources/redirectingTo/reducer.js